import React from "react";

const DeliveryOrderItemTable = ({ data }: { data: any }) => {
  const productData = data?.items || [];
  const getUnitLabel = (product: any) =>
    product?.unit_name ||
    product?.base_unit_name ||
    product?.unit?.unit_name ||
    product?.unit ||
    "-";

  const allocationAccountNames: string[] = Array.from(
    new Set(
      (data?.warehouses || []).map((warehouse: any) => warehouse.warehouse_name)
    )
  ).filter(Boolean);

  const columnTotals = allocationAccountNames.reduce(
    (acc: Record<string, number>, name) => {
      acc[name] = productData.reduce((sum: number, product: any) => {
        const match = product.warehouses.find(
          (warehouse: any) => warehouse.warehouse_name === name
        );
        return sum + Number(match?.total_base_qty || 0);
      }, 0);
      return acc;
    },
    {}
  );

  return (
    <div className="overflow-x-auto">
      <table className="table-auto border border-gray-300 w-full min-w-[800px] text-sm">
        <thead className="bg-gray-100">
          <tr>
            <th className="px-4 py-2 border text-left">Product Code</th>
            <th className="px-4 py-2 border text-left">Product Name</th>
            <th className="px-4 py-2 border text-left">Unit</th>
            {allocationAccountNames.map((wh, idx) => (
              <th key={idx} className="px-4 py-2 border text-left">
                {wh}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {productData.map((product: any, idx: number) => {
            return (
              <tr key={idx} className="hover:bg-gray-50">
                <td className="px-4 py-2 border">
                  {product.product_code_prefix
                    ? `${product.product_code_prefix}${product.product_code}`
                    : product.product_code}
                </td>
                <td className="px-4 py-2 border">{product.product_name}</td>
                <td className="px-4 py-2 border">{getUnitLabel(product)}</td>
                {allocationAccountNames.map((whName, i) => {
                  const match = (product.warehouses || []).find(
                    (w: any) => w.warehouse_name === whName
                  );
                  return (
                    <td key={i} className="px-4 py-2 border text-left ">
                      {match ? match.total_base_qty : 0}
                    </td>
                  );
                })}
              </tr>
            );
          })}
          <tr className="font-bold">
            <td colSpan={3} className="px-4 py-2 border text-left">
              Total
            </td>
            {allocationAccountNames.map((name, idx) => (
              <td key={idx} className="px-4 py-2 border text-left">
                {columnTotals[name] || 0}
              </td>
            ))}
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default DeliveryOrderItemTable;
